<template>
  <div>
    <a-card :title="$t('出库通知单')">
      <a-button slot="extra" type="primary" icon="left" ghost @click="goBack">{{ $t("返回") }}</a-button>

      <a-spin :spinning="loading">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
          <a-row>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="number" :label="$t('出库通知单号')">
                <a-input v-model="form.number" allowClear />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="warehouse" :label="$t('仓库')">
                <a-select v-model="form.warehouse" style="width: 100%">
                  <a-select-option v-for="item in warehouseItems" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="client" :label="$t('货主')">
                <a-select v-model="form.client" style="width: 100%">
                  <a-select-option v-for="item in clientItems" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="order_type" :label="$t('订单类型')">
                <a-select v-model="form.order_type" style="width: 100%">
                  <a-select-option v-for="item in orderTypeItems" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="external_number" :label="$t('往来单位单号')">
                <a-input v-model="form.external_number" allowClear />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="customer_contact" :label="$t('收货人')">
                <a-input v-model="form.customer_contact" allowClear />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="receiving_address" :label="$t('收货地址')">
                <a-input v-model="form.receiving_address" allowClear />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="arrival_date" :label="$t('预计到货日期')">
                <a-date-picker v-model="form.arrival_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="width: 320px">
              <a-form-model-item prop="remark" :label="$t('备注')">
                <a-input v-model="form.remark" allowClear />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>

        <a-divider></a-divider>

        <div>
          <a-row :gutter="16">
            <a-col :span="24" :md="8" :xl="6" style="width: 256px">
              <a-input
                v-model="materialNumber"
                :placeholder="$t('请扫描货品条码')"
                @keyup.enter.native="scanMaterial"
                allowClear
              />
            </a-col>
            <a-space>
              <a-button type="primary" @click="openInventoryModal">{{ $t("选择货品") }}</a-button>
            </a-space>
          </a-row>

          <div style="margin-top: 16px">
            <a-table
              rowKey="id"
              size="small"
              :loading="tableLoading"
              :columns="columns"
              :data-source="deliveryMaterialItems"
              :pagination="false"
            >
              <div slot="batch" slot-scope="value, item, index">
                <batch-search-select
                  v-model="item.batch"
                  :placeholder="$t('批次')"
                  :warehouse="form.warehouse"
                  :material="item.material"
                  size="small"
                  :defaultItem="item"
                >
                </batch-search-select>
              </div>
              <div slot="total_quantity" slot-scope="value, item, index">
                <a-input-number v-model="item.total_quantity" size="small"></a-input-number>
              </div>
              <div slot="weight" slot-scope="value, item, index">
                <span v-if="item.total_quantity && item.material_weight">
                  {{ NP.times(item.total_quantity, item.material_weight || 0, 0.001) }}
                </span>
              </div>
              <div slot="volume" slot-scope="value, item, index">
                <span v-if="item.total_quantity && item.material_volume">
                  {{ NP.times(item.total_quantity, item.material_volume) }}
                </span>
              </div>
              <div slot="action" slot-scope="value, item, index">
                <a-button-group size="small">
                  <a-button type="danger" @click="removeMaterial(item, index)">{{ $t("删除") }}</a-button>
                  <a-button type="primary" @click="copyMaterial(item, index)">{{ $t("复制") }}</a-button>
                  <a-button @click="autoPicking(item, index)">{{ $t("自动拣配") }}</a-button>
                </a-button-group>
              </div>
            </a-table>
          </div>
        </div>
      </a-spin>

      <div style="margin-top: 32px">
        <a-popconfirm :title="$t('确定创建吗?')" @confirm="create">
          <a-button type="primary" :loading="loading">{{ $t("创建") }}</a-button>
        </a-popconfirm>
      </div>
    </a-card>

    <inventory-select-modal
      v-model="materialModalVisible"
      :warehouse="form.warehouse"
      :client="form.client"
      @select="onSelectMaterial"
    >
    </inventory-select-modal>
  </div>
</template>

<script>
import { getDeliveryNumber } from "@/api/data";
import { batchOption, clientOption, materialOption, orderTypeOption, userOption, warehouseOption } from "@/api/option";
import { deliveryDetail, deliveryMaterials, deliveryOrderCreate } from "@/api/stockOut";
import moment from "moment";
import NP from "number-precision";
import { columns } from "./columns";
import { rules } from "./rules";

export default {
  components: {
    InventorySelectModal: () => import("@/components/InventorySelectModal/index"),
    BatchSearchSelect: () => import("@/components/BatchSearchSelect/index"),
  },
  data() {
    return {
      NP,
      rules,
      moment,
      columns,
      loading: false,
      tableLoading: false,
      form: {},
      deliveryMaterialItems: [],

      orderTypeItems: [],
      userItems: [],
      clientItems: [],
      warehouseItems: [],
      materialNumber: "",
      materialModalVisible: false,
    };
  },
  methods: {
    initData() {
      this.resetForm();
      let deliveryOrder = this.$route.query.id;

      getDeliveryNumber().then((data) => {
        this.form.number = data.number;
      });

      deliveryDetail({ id: deliveryOrder }).then((data) => {
        this.form.warehouse = data.warehouse;
        this.form.client = data.client;
        this.form.order_type = data.order_type;
        this.form.external_number = data.external_number;
        this.form.customer_contact = data.customer_contact;
        this.form.receiving_address = data.receiving_address;
        this.form.arrival_date = data.arrival_date;
        this.form.remark = data.remark;
      });

      deliveryMaterials({ id: deliveryOrder }).then((data) => {
        this.deliveryMaterialItems = data;
      });

      warehouseOption({ page_size: 999999 }).then((data) => {
        this.warehouseItems = data.results;
      });

      orderTypeOption({ page_size: 999999 }).then((data) => {
        this.orderTypeItems = data.results;
      });

      userOption({ page_size: 999999 }).then((data) => {
        this.userItems = data.results;
      });

      clientOption({ page_size: 999999 }).then((data) => {
        this.clientItems = data.results;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    onSelectMaterial(item) {
      let index = this.deliveryMaterialItems.findIndex((_item) => _item.id == item.id);
      if (index != -1) {
        this.$message.warn(this.$t("货品已存在"));
        return;
      }

      this.deliveryMaterialItems = this.$functions.insertItem(this.deliveryMaterialItems, {
        id: item.material,
        material: item.material,
        material_name: item.material_name,
        material_number: item.material_number,
        total_quantity: 1,
        unit: item.unit,
        material_volume: item.material_volume,
        material_weight: item.material_weight,
        material_spec: item.material_spec,
      });
    },
    create() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.deliveryMaterialItems.length == 0) {
            this.$message.warn(this.$t("未添加货品"));
            return;
          }

          for (let item of this.deliveryMaterialItems) {
            if (!item.batch) {
              this.$message.warn(this.$t("未选择批次"));
              return;
            }
          }

          let formData = { ...this.form, delivery_material_items: this.deliveryMaterialItems };
          this.loading = true;
          deliveryOrderCreate(formData)
            .then((data) => {
              this.$message.success(this.$t("创建成功"));
              this.resetForm();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm() {
      this.form = {
        number: undefined,
        warehouse: undefined,
        client: undefined,
        order_type: undefined,
        external_number: undefined,
        customer_contact: undefined,
        receiving_address: undefined,
        arrival_date: undefined,
        remark: undefined,
      };
      this.deliveryMaterialItems = [];
    },
    scanMaterial() {
      if (!this.materialNumber) {
        this.$message.warning(this.$t("请扫描货品条码"));
        return false;
      }
      this.tableLoading = true;
      materialOption({ number: this.materialNumber })
        .then((data) => {
          if (!data.results.length) {
            this.$message.warning(this.$t("没有找到相关货品, 请确认扫描的货品编号！"));
            return false;
          }
          let item = data.results[0];
          let index = this.deliveryMaterialItems.findIndex((_item) => _item.id == item.id);
          if (index != -1) {
            this.deliveryMaterialItems = this.$functions.replaceItem(this.deliveryMaterialItems, {
              id: item.id,
              material: item.id,
              material_name: item.name,
              material_number: item.number,
              total_quantity: this.deliveryMaterialItems[index].total_quantity + 1,
              unit: item.unit,
              material_volume: item.volume,
              material_weight: item.weight,
              material_spec: item.spec,
            });
          } else {
            this.deliveryMaterialItems = this.$functions.insertItem(this.deliveryMaterialItems, {
              id: item.id,
              material: item.id,
              material_name: item.name,
              material_number: item.number,
              total_quantity: 1,
              unit: item.unit,
              material_volume: item.volume,
              material_weight: item.weight,
              material_spec: item.spec,
            });
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    openInventoryModal() {
      if (!this.form.warehouse) {
        this.$message.warn(this.$t("请选择仓库"));
        return;
      }
      if (!this.form.client) {
        this.$message.warn(this.$t("请选择货主"));
        return;
      }
      this.materialModalVisible = true;
    },
    removeMaterial(item, index) {
      this.deliveryMaterialItems.splice(index, 1);
    },
    copyMaterial(item, index) {
      this.deliveryMaterialItems.splice(index, 0, { ...item });
    },
    autoPicking(item, index) {
      this.tableLoading = true;
      let searchForm = {
        page: 1,
        page_size: 999999,
        has_stock: true,
        warehouse: this.form.warehouse,
        material: item.material,
      };
      batchOption(searchForm)
        .then((data) => {
          let materialItems = [];
          let totalQuantity = item.total_quantity;
          for (let batchItem of data.results) {
            if (totalQuantity > batchItem.remain_quantity) {
              materialItems.push({
                ...item,
                batch: batchItem.id,
                batch_number: batchItem.number,
                total_quantity: batchItem.remain_quantity,
              });

              totalQuantity -= batchItem.remain_quantity;
            } else {
              materialItems.push({
                ...item,
                batch: batchItem.id,
                batch_number: batchItem.number,
                total_quantity: totalQuantity,
              });

              break;
            }
          }
          this.deliveryMaterialItems.splice(index, 1, ...materialItems);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
